<script setup lang="ts">
import type { ProductsList } from "~/models/Content/ContentProducts"
import { NuxtLink } from "#components"

const props = defineProps<{ product: ProductsList }>()

const variant = computed(() => props.product.variants.find(v => !!v.ean))

const imageWrapperClass = computed(() => [
  "rounded-bl-none rounded-tl-2xl rounded-tr-2xl lg:rounded-bl-2xl lg:rounded-tl-2xl lg:rounded-tr-none",
  "w-full lg:w-[320px] lg:min-w-[320px]",
  "h-[281px] md:h-auto md:min-h-[320px]",
  `p-4 bg-${props.product.theme}-lightest`,
])
</script>

<template>
  <div class="flex flex-col rounded-2xl bg-platform-white font-national2 drop-shadow-xl lg:gap-14 lg:flex-row">
    <NuxtLink
      v-if="variant && product.hasAtLeastOneReleasedProduct"
      :class="imageWrapperClass"
      :to="{ name: 'product', params: { product: product.urlFormatProductTitle } }"
    >
      <UProductImage :product="variant" img-class="object-contain size-full" />
    </NuxtLink>
    <div v-else :class="imageWrapperClass" />
    <div
      class="flex flex-col w-full px-6 py-7 lg:py-10 lg:pl-0 lg:pr-24"
    >
      <h4
        class="font-national2compressed text-[32px] font-extrabold uppercase leading-10 text-[--theme-dark] md:text-5xl"
      >
        Kunne
        <span v-html="product.productTitleHtml" />
        {{ !product.productTitleHtml ? product.productTitle : null }}
      </h4>
      <p
        v-if="
          product.groupSalesPitch &&
          product.groupSalesPitch.length > 2
        "
        class="pr-10 mt-2 mb-5 text-lg lg:mb-10 lg:mt-4 md:text-xl"
        v-html="product.groupSalesPitch"
      />
      <UProductActions
        :product="product"
        view-type="list"
        align="left"
        :show-status-details="false"
      />
    </div>
  </div>
</template>
